export default __webpack_public_path__ + "static/Plots0106-86111a6d49c162e9a96fc33c491a9300.jpg";